import { createReducer } from "@reduxjs/toolkit";
import { AuviousRtcState, DEFAULT_ICE_SERVERS } from "./model";
import { registerRequest, registerSuccess, registerFailure, createEndpointSuccess, setWasPreviouslyConnectedToMqtt, unregisterSuccess, unregisterFailure, setBrowserAction, setStatsAction, } from "./actions";
import { combineReducers } from "redux";
import { joinedConferencesReducer } from "./conference/reducers";
const stateReducer = createReducer(AuviousRtcState.UNREGISTERED, {
    [registerRequest.type]: () => AuviousRtcState.REGISTERING,
    [registerSuccess.type]: () => AuviousRtcState.REGISTERED,
    [registerFailure.type]: () => AuviousRtcState.UNREGISTERED,
    [unregisterSuccess.type]: () => AuviousRtcState.UNREGISTERED,
    [unregisterFailure.type]: () => AuviousRtcState.UNREGISTERED,
});
const identityReducer = createReducer(null, {
    [createEndpointSuccess.type]: (_state, action) => action.payload.identity,
    [unregisterSuccess.type]: () => null,
    [unregisterFailure.type]: () => null,
});
const endpointReducer = createReducer(null, {
    [createEndpointSuccess.type]: (_state, action) => action.payload.endpoint,
    [unregisterSuccess.type]: () => null,
    [unregisterFailure.type]: () => null,
});
const wasPreviouslyConnectedToMqttReducer = createReducer(null, {
    [setWasPreviouslyConnectedToMqtt.type]: (_state, action) => action.payload,
    [unregisterSuccess.type]: () => null,
    [unregisterFailure.type]: () => null,
});
const iceServersReducer = createReducer(DEFAULT_ICE_SERVERS, {
    [registerSuccess.type]: (state, action) => {
        if (action.payload.iceServers) {
            //    state.iceServers = action.payload.iceServers;
            return action.payload.iceServers;
        }
        return null;
    },
    [unregisterSuccess.type]: () => DEFAULT_ICE_SERVERS,
    [unregisterFailure.type]: () => DEFAULT_ICE_SERVERS,
});
const browserReducer = createReducer(null, {
    [setBrowserAction.type]: (_, action) => action.payload,
});
const statsReducer = createReducer(null, {
    [setStatsAction.type]: (_, action) => action.payload,
});
export const rootReducer = combineReducers({
    state: stateReducer,
    identity: identityReducer,
    endpoint: endpointReducer,
    iceServers: iceServersReducer,
    wasPreviouslyConnectedToMqtt: wasPreviouslyConnectedToMqttReducer,
    joinedConferences: joinedConferencesReducer,
    browser: browserReducer,
    keepStats: statsReducer,
});
//# sourceMappingURL=reducers.js.map